import { render, staticRenderFns } from "./ReturnDetailComponent.vue?vue&type=template&id=593d0c58"
import script from "./ReturnDetailComponent.vue?vue&type=script&lang=js"
export * from "./ReturnDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports